export default "data:image/gif;base64,R0lGODlhEgAMAPIBAP8AAP///wAAiwAAAOXl5QAAAAAAAAAAACH5BAAAAAAALAAAAAASAAwAAAMeCLrc/jDK6Ui4OOtA7P5XB4LiuBFCqq5s675wLLcJADs="